import React from 'react'
import PropTypes from "prop-types"
import { FormGroup, ControlLabel, Modal } from 'react-bootstrap'
import moment from 'moment'
import { keys } from 'lodash'
import { DateTimePicker } from 'react-widgets'

import { str2date, date2str } from '../../../lib/Tools'
import Button from '../../components/Button.jsx'
import { getText } from '../../lib/text.js'
import { addSchedule, checkOverlap, timetablePropType, getLastScheduledDate } from '../timetable'

import "./timetableEditor.less"

const getNewSchedule = (oldTimeTable, newTimeTable) => {
  let newSchedule = ""
  keys(newTimeTable.schedules).forEach(key => {
    if (!oldTimeTable.schedules[key]) newSchedule = newTimeTable.schedules[key]
  })
  return newSchedule
}


export const addSchedule2 = (timetable, startDate, endDate) => {
  const ntt = addSchedule(timetable, startDate, endDate)
  return { timetable: ntt, schedule: getNewSchedule(timetable, ntt) }
}


export default class AddScheduleModal extends React.PureComponent {
  constructor(props) {
    super(props)

    // from last scheduled date, to end of that month
    const lastSchDate = getLastScheduledDate(props.timetable) || undefined
    const startDate = moment(lastSchDate).add(1, "day").format("YYYY/MM/DD")
    const endDate = moment(startDate).endOf("month").format("YYYY/MM/DD")

    this.state = {
      startDate,
      endDate,
      overlap: checkOverlap(props.timetable, startDate, endDate).overlap,
    }
  }

  componentDidUpdate(_prevProps, _prevState) {
    if (this.state.startDate && this.state.endDate) {
      this.setState({
        overlap: checkOverlap(this.props.timetable, this.state.startDate, this.state.endDate).overlap,
      })
    }
  }

  ready() {
    return (
      this.state.startDate && this.state.endDate
      && this.state.endDate >= this.state.startDate
      && !this.state.overlap
    )
  }

  props: {
    timetable: timetablePropType.isRequired,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  render() {
    const { timetable, onClose, onChange } = this.props
    return (
      <Modal show onHide={() => this.props.onClose()} className="add-schedule-modal">
        <Modal.Header>{getText(`Añadir horario`)}</Modal.Header>
        <Modal.Body>
          <div>
            <FormGroup>
              <ControlLabel>{getText("De")}</ControlLabel>
              <DateTimePicker
                calendar
                time={false}
                format="LL"
                editFormat="YYYY/MM/DD"
                value={this.state.startDate ? str2date(this.state.startDate) : null}
                onChange={d => this.setState({ startDate: date2str(d) })}
              />
              <ControlLabel>{` ${getText("a")} `}</ControlLabel>
              <DateTimePicker
                calendar
                time={false}
                format="LL"
                editFormat="YYYY/MM/DD"
                value={this.state.endDate ? str2date(this.state.endDate) : null}
                onChange={d => this.setState({ endDate: date2str(d) })}
              />
            </FormGroup>
            {
              this.state.overlap && (
                <div className="error">❌ Este horario se solapa con otro existente</div>
              )
            }
            {
              this.state.endDate < this.state.startDate && (
                <div className="error">❌ Fechas inválidas</div>
              )
            }
          </div>
          <div className="direct-accesses">
            <label>Ejemplos:</label>
            {
              [
                {
                  label: "Este mes",
                  startDate: moment().startOf("month").format("YYYY/MM/DD"),
                  endDate: moment().endOf("month").format("YYYY/MM/DD"),
                },
                {
                  label: "Mes que viene",
                  startDate: moment().add(1, "month").startOf("month").format("YYYY/MM/DD"),
                  endDate: moment().add(1, "month").endOf("month").format("YYYY/MM/DD"),
                },
                {
                  label: "Todo este año",
                  startDate: moment().startOf("year").format("YYYY/MM/DD"),
                  endDate: moment().endOf("year").format("YYYY/MM/DD"),
                },
                {
                  label: "Este año y el que viene",
                  startDate: moment().startOf("year").format("YYYY/MM/DD"),
                  endDate: moment().add(1, "year").endOf("year").format("YYYY/MM/DD"),
                }
              ].map(({ label, startDate, endDate }) => (
                <Button key={label} bsStyle="link" onClick={() => this.setState({ startDate, endDate })} label={label} />
              ))
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onClose()} label={getText("Cancelar")} />
          <Button
            disabled={!this.ready()}
            bsStyle="success"
            onClick={() => onChange(addSchedule2(timetable, this.state.startDate, this.state.endDate))}
            label={getText("Añadir")}
          />
        </Modal.Footer>
      </Modal>
    )
  }
}
